import { render, staticRenderFns } from "./AddUserToMatchDialog.vue?vue&type=template&id=7d0904c6&scoped=true"
import script from "./AddUserToMatchDialog.vue?vue&type=script&lang=js"
export * from "./AddUserToMatchDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0904c6",
  null
  
)

export default component.exports